import axios from "axios";

export function updateEmail(value) {
    return {
        type: "UPDATE_SIGN_UP_EMAIL",
        value,
        errors: validateEmail(value)
    };
}

export function updatePassword(value) {
    return {
        type: "UPDATE_SIGN_UP_PASSWORD",
        value,
        errors: validatePassword(value)
    };
}

export function updatePasswordConfirmation(password, passwordConfirmation) {
    return {
        type: "UPDATE_SIGN_UP_PASSWORD_CONFIRMATION",
        value: passwordConfirmation,
        errors: validatePasswordConfirmation(password, passwordConfirmation)
    };
}

export function updateFirstName(value) {
    return {
        type: "UPDATE_SIGN_UP_FIRST_NAME",
        value,
        errors: validateFirstName(value)
    };
}

export function updateLastName(value) {
    return {
        type: "UPDATE_SIGN_UP_LAST_NAME",
        value,
        errors: validateLastName(value)
    };
}

export function updatePhoneNumber(value) {
    return {
        type: "UPDATE_SIGN_UP_PHONE_NUMBER",
        value,
        errors: validatePhoneNumber(value)
    };
}

export function updateDanceSchool(value) {
    return {
        type: "UPDATE_SIGN_UP_DANCE_SCHOOL",
        value,
        errors: validateDanceSchool(value)
    };
}

export function updateTerms(value) {
    return {
        type: "UPDATE_SIGN_UP_TERMS",
        value,
        errors: validateTerms(value)
    };
}

export function signUp(email, password, firstName, lastName, phoneNumber, danceSchool) {
    return {
        type: "SIGN_UP",
        payload: axios.post("/rest/authentication/sign-up", {
            email,
            password,
            firstName,
            lastName,
            phoneNumber,
            danceSchool
        })
    }
}

export function confirmEmail(token) {
    return {
        type: "CONFIRM_EMAIL",
        payload: axios.post("/rest/authentication/sign-up/" + token)
    }
}

export function initSignUpForm() {
    return {
        type: "INIT_SIGN_UP_FORM",
        email: "",
        emailErrors: validateEmail(""),
        password: "",
        passwordErrors: validatePassword(""),
        passwordConfirmation: "",
        passwordConfirmationErrors: validatePasswordConfirmation(""),
        firstName: "",
        firstNameErrors: validateFirstName(""),
        lastName: "",
        lastNameErrors: validateLastName(""),
        phoneNumber: "",
        phoneNumberErrors: validatePhoneNumber(""),
        danceSchool: "",
        danceSchoolErrors: validateDanceSchool(""),
        terms: false,
        termsErrors: validateTerms(false)
    }
}

export function displayValidationErrors() {
    return {
        type: "DISPLAY_SIGN_UP_VALIDATION_ERRORS"
    }
}

function validateEmail(value) {
    var errors = [];
    if (!value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
        errors.push("Nieprawidłowy adres e-mail")
    }
    return errors;
}

function validatePassword(value) {
    var errors = [];
    if (value.length < 8) {
        errors.push("Hasło nie może być krótsze niż 8 znaków")
    }
    if (value.length > 40) {
        errors.push("Hasło nie może być dłuższe niż 40 znaków")
    }
    return errors;
}

function validatePasswordConfirmation(password, passwordConfirmation) {
    var errors = [];
    if (password !== passwordConfirmation) {
        errors.push("Hasła muszą być identyczne")
    }
    return errors;
}

function validateFirstName(value) {
    var errors = [];
    if (!value.match(/^[A-Za-zĄąĆćĘęŁłŃńÓóŚśŻżŹź]*$/)) {
        errors.push("Imię może składać się wyłącznie z liter")
    }
    if (value.length < 2) {
        errors.push("Imię nie może być krótsze niż 2 znaki")
    }
    if (value.length > 20) {
        errors.push("Imię nie może być dłuższe niż 20 znaków")
    }
    return errors;
}

function validateLastName(value) {
    var errors = [];
    if (!value.match(/^[A-Za-zĄąĆćĘęŁłŃńÓóŚśŻżŹź]+[-]{0,1}[A-Za-zĄąĆćĘęŁłŃńÓóŚśŻżŹź]*$/)) {
        errors.push("Nazwisko może składać się wyłącznie z liter i jednego znaku '-'")
    }
    if (value.length < 2) {
        errors.push("Nazwisko nie może być krótsze niż 2 znaki")
    }
    if (value.length > 40) {
        errors.push("Nazwisko nie może być dłuższe niż 40 znaków")
    }
    return errors;
}

function validatePhoneNumber(value) {
    var errors = [];
    if (!value.match(/^[0-9]{9}$/)) {
        errors.push("Numer telefony musi mieć dokładnie 9 cyfr")
    }
    return errors;
}

function validateDanceSchool(value) {
    var errors = [];
    if (!value.match(/^[-&0-9A-Za-zĄąĆćĘęŁłŃńÓóŚśŻżŹź\s]*$/)) {
        errors.push("Nazwa szkoły tańca może składać się wyłącznie z liter, cyfr, spacji i znaków '-' oraz '&'")
    }
    if (value.length < 2) {
        errors.push("Nazwa szkoły tańca nie może być krótsza niż 2 znaki")
    }
    if (value.length > 40) {
        errors.push("Nazwa szkoły tańca nie może być dłuższa niż 40 znaków")
    }
    return errors;
}

function validateTerms(value) {
    var errors = [];
    if (!value) {
        errors.push("Aby utworzyć konto w serwisie konieczne jest wyrażenie powyższej zgody")
    }
    return errors;
}


// WEBPACK FOOTER //
// ./src/actions/signUp.js